const notification = document.createElement("div");
const timer = document.createElement("div");
const anim = document.createElement("style");
const TIMER_STORAGE_KEY = "krunker_elapsed_timer_seconds";

let elapsedSeconds = 0;

try {
  const savedSeconds = Number(localStorage.getItem(TIMER_STORAGE_KEY));
  if (Number.isFinite(savedSeconds) && savedSeconds > 0) {
    elapsedSeconds = Math.floor(savedSeconds);
  }
} catch {}

function formatTimer(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  const pad = (value: number): string => String(value).padStart(2, "0");

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

function saveTimer(): void {
  try {
    localStorage.setItem(TIMER_STORAGE_KEY, String(elapsedSeconds));
  } catch {}
}

function updateTimer(): void {
  timer.textContent = formatTimer(elapsedSeconds);
}

function isInMenus(): boolean {
  return !!document.getElementById("uiBase")?.classList.contains("onMenu");
}

timer.style.cssText = `
  position: absolute;
  z-index: 9999;
  top: 10px;
  right: 10px;
  padding: 10px;
  margin: 10px;
  box-sizing: border-box;
  border-radius: 5px;
  background: #0005;
  color: #fff;
  text-align: center;
  pointer-events: none;
`;

notification.style.cssText = `
  position: absolute;
  z-index: 9999;
  top: 58px;
  right: 10px;
  transform: translateX(calc(100% + 20px));
  padding: 10px;
  margin: 10px;
  box-sizing: border-box;
  border-radius: 5px;
  background: #0005;
  color: #fff;
`;

anim.textContent = `
  @keyframes slide {
      0%, 100% {
          transform: translateX(calc(100% + 20px));
      }
  
      10%, 90% {
          transform: translateX(0);
      }
  }
  
  .anim {
      animation: slide 2s forwards;
  }
`;

function waitFor<T>(
  check: () => T | null | undefined | false,
  interval = 50,
): Promise<T> {
  return new Promise((resolve) => {
    let timer: ReturnType<typeof setInterval> | undefined;

    const run = (): boolean => {
      try {
        const result = check();

        if (result) {
          if (timer) clearInterval(timer);
          resolve(result);
          return true;
        }
      } catch (err) {
        console.error(err);
      }

      return false;
    };

    if (!run()) timer = setInterval(run, interval);
  });
}

waitFor(() => document.body).then(() => {
  updateTimer();
  document.body.append(timer, notification, anim);

  setInterval(() => {
    if (isInMenus()) return;

    elapsedSeconds++;
    updateTimer();
  }, 1000);

  setInterval(saveTimer, 2e3);
});

function notify(message: string): void {
  notification.innerHTML = message;
  notification.className = "";

  void notification.offsetHeight;
  notification.className = "anim";
}

window.notify = notify;

export default notify;
